<nav class="navbar bg-white h-84 shadow-sm" *ngIf="!isMobile">
    <div class="container-fluid">
        <a class="navbar-brand ps-md-5">
            <img src="./assets/images/sbiheader.png" alt="Logo" class="img-fluid">
        </a>
    </div>
</nav>

<div class="row mx-0  register">
    <div class="col-md-6 col-lg-6 col-xl-8 col-sm-6 text-center">
        <!-- <img src="./assets/images/Axis-Direct-Logo-ffffff@2x.png" class="mt-md-5 mt-4 img-fluid" width="auto" /> -->
        <div class="d-flex align-items-center h-md-50 w-md-100 w-75">
            <div class="text-white flex-fill text-start mt-md-4 mt-4 mb-5 mb-md-0">
                <h1 class="mt-md-5 px-md-5 px-3 fw-bold  clrtxt"> Go Global on Investments </h1>
                <h1 class="fw-normal px-md-5 px-3 clrtxt"> with your </h1>
                <!-- <h1 class="px-md-5 px-3 fw-bold  clrtxt mb-0"> NRI Demat & Trading <br> Account</h1> -->
                <h1 class="px-md-5 px-3 fw-bold clrtxt mb-0">
                    NRI Demat & Trading
                    <span class="d-none d-md-inline"> </span>
                    <span class="d-inline d-md-none"><br></span>
                    Account
                </h1>
            </div>
        </div>

    </div>
    <div class="col-md-6 col-xl-4 my-1 py-md-5 d-flex justify-content-center" *ngIf="resumeJourney">
        <div class="card resume-screen ml-auto  mt-md-5 me-md-5 shadow-sm border-0">
            <div class="card-body">
                <div class="row">
                    <button type="button" class="btn-close ms-auto me-3" data-bs-dismiss="modal" aria-label="Close"
                        (click)="resumeJourney = false;"></button>
                </div>
                <div class="row mt-3">
                    <div class="col-md-12 text-center">
                        <p class="text-gradient fw-bold">Open Your NRI Demat & Trading Account Now !</p>
                    </div>
                </div>
                <div class="row" *ngIf="!resumeOTPArea">
                    <div class="col-md-12 text-center">
                        <p class="text-gradient fw-bold mb-1">Resume Application Status</p>
                    </div>
                    <div class="col-md-12 text-center mb-2">
                        <small class="fw-bold">Please enter PAN and validate OTP to Resume your journey.</small>
                    </div>
                    <!-- <div class="col-md-2"></div> -->
                    <div class="col-md-12 px-md-4 my-2">
                        <div class="form-floating">
                            <input class="form-control  text-uppercase" type="text" placeholder="Enter PAN" #resumeInput
                                id="resume-pan" [(ngModel)]="resumePan"
                                (input)="resumePanError = false;onPanChange($event)" maxlength="10"
                                autocomplete="off" />
                            <label for="resume-pan">Enter your Registered PAN <span class="text-danger">*</span></label>
                        </div>
                        <div *ngIf="resumePanError" class="">
                            <span class="small text-danger">Please Enter Valid PAN</span>
                        </div>
                    </div>
                    <!-- <div class="col-md-2"></div> -->
                    <div class="col-md-12 text-center my-2">
                        <button type="button" class="btn btn-primary  px-4" (click)="panResumeVal()">
                            Generate OTP
                        </button>
                    </div>
                </div>

                <div class="row mx-0" *ngIf="resumeOTPArea">
                    <div class="col-md-12 text-center">
                        <p class="text-gradient fw-bold">Resume Application Status</p>
                    </div>
                    <div class="col-md-12 text-center mb-2">
                        <small class="fw-bold">Confirm the 4-digit OTP sent to the Email address.</small>
                    </div>
                    <div class="col-md-12 text-center">
                        <ng-otp-input class="my-4" #ngOtpInput (onInputChange)="resumeotp($event)"
                            [config]="config"></ng-otp-input>
                    </div>
                    <div class="col-md-12 text-end mt-md-2 pe-md-5">
                        <div class="row">
                            <div *ngIf="otpResumeError" class="col-7">
                                <span class="small text-danger" style="font-size: 0.75rem !important;">Please enter
                                    Valid OTP.</span>
                            </div>
                            <div class="text-end" [ngClass]="otpResumeError ? 'col-5' : 'col-12'">
                                <span class="px-3 py-2" id="otptimer">
                                    <count-down class="text-primary" (reSendTimer)="reSendOTPStatus($event)"
                                        *ngIf="!reSendOTP && timer"></count-down>
                                    <span *ngIf="reSendOTP" (click)="panResumeVal()" class="small text-primary">Re-Send
                                        OTP</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 text-center my-2">
                        <button type="button" class="btn btn-primary  px-4" (click)="resumeOTPVal()">
                            Validate
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-lg-6 col-xl-4 col-sm-6 my-1 px-1 py-md-5 d-flex justify-content-center">
        <div class="card border-0 shadow-sm rounded-4 login-screen" [ngClass]="rmAssist ? 'h-550' : ''"
            *ngIf="!regScreen && !resumeJourney">
            <div class="card-body py-md-2 p-1 d-grid justify-content-center">
                <div class="row my-2 me-0">
                    <div class="col-lg-12">
                        <label class="text-md-start text-center text-gradient fw-bold ps-md-2 ms-md-1 f-24">Open Your
                            NRI Account Now !</label>
                    </div>
                    <!-- <div class="col-md mt-md-0 mt-3 text-end ">
                        <span class="continue text-gradient" (click)="resumeApp()">Continue Journey</span> <img src="./assets/images/flight.svg" height="24" class="ms-2">
                    </div> -->
                </div>

                <form [formGroup]="registerForm" novalidate>
                    <div class="row mx-0 mt-3">
                        <div class="col-lg-12 col-md-12 ps-md-2 px-0 h-90">
                            <div class="pe-md-4 mb-md-4 mb-4">
                                <div class="input-group  border form-floating pan-auto" id="autoCom">
                                    <input type="text" #countryCodeInput="ngModel" (paste)="(false)" placeholder="Code"
                                        [ngModelOptions]="{standalone: true}"
                                        class="form-control my-1 me-2 border-top-0 border-start-0 border-end-0 border-bottom-0 pe-0 ps-75 py-0 position-relative"
                                        (click)="focus()" [(ngModel)]="newCoun" readonly maxlength="7" id="showw"
                                        autocomplete="off">
                                    <span class="d-flex justify-content-center align-items-center me-1"><a
                                            (click)="focus()" style="cursor: pointer;"><img
                                                src="./assets/images/arrow-down.png" width="18" height="18"></a></span>
                                    <label for="showw">Code<span class="text-danger">*</span></label>
                                    <ng-autocomplete class="position-absolute shadow-sm border bg-white"
                                        style="top: 38px;" *ngIf="inline" [data]="countryList"
                                        [searchKeyword]="codeKeyword" [customFilter]="filter" placeholder=""
                                        [itemTemplate]="itemTemplate" [(ngModel)]="countryCode"
                                        [ngModelOptions]="{standalone: true}" name="source" mdbInput autocomplete="on"
                                        (inputChanged)='telcode($event)' (input)='alphaNumeric($event)'
                                        (closed)="checkCode()" (selected)='selectCodeEvent($event)'
                                        (keydown)="restrictEnter($event)" id="countryCode" #autocomplete required
                                        [notFoundTemplate]="notFoundTemplate" #countryCodeInput="ngModel"
                                        [disabled]="codeDisable">
                                    </ng-autocomplete>

                                    <!-- <label [ngClass]="countryCode ? 'pin-top':''">Code<span class="text-danger">*</span></label> -->
                                    <ng-template #itemTemplate let-item>
                                        <a [innerHTML]="item.TeleCode"></a> <a [innerHTML]="item.Name"></a>
                                    </ng-template>

                                    <ng-template #notFoundTemplate let-notFound>
                                        <div [innerHTML]="notFound"></div>
                                    </ng-template>
                                    <div class="form-floating">
                                        <input type="text" (paste)="(false)"
                                            class="form-control my-1 me-2 border-top-0 border-end-0  border-bottom-0 pe-0 ps-75 py-0"
                                            autocomplete="off" (input)='numericOnly($event)' maxlength="15" id="mobile"
                                            formControlName="Mobile" placeholder="Enter Mobile Number">
                                        <label for="mobile" class="left">Mobile Number <span
                                                class="text-danger">*</span></label>
                                    </div>

                                </div>
                                <div class="ms-3"
                                    *ngIf="countryCodeError || (countryCodeInput.invalid && countryCodeInput.touched)"
                                    [ngClass]="{'text-danger': countryCodeError || (countryCodeInput.invalid && countryCodeInput.touched)}">
                                    <span class="small">Valid Country Tele Code is required.</span>
                                </div>

                                <!-- <div *ngIf="countryCodeError" class="ms-3 mt-2">
                                    <span class="small text-danger">Valid Country Tele Code is required.</span>
                                </div>
                                <div class="ms-3 mt-2" *ngIf="countryCodeInput.invalid && countryCodeInput.touched">
                                    <span class="small text-danger">Valid Country Tele Code is required.</span>
                                  </div> -->
                                <div *ngIf="registerForm.controls.Mobile.touched" class="ms-3">
                                    <span class="small text-danger"
                                        *ngIf="registerForm.controls.Mobile.errors?.['required']">Mobile Number is
                                        required.</span>
                                    <span class="small text-danger"
                                        *ngIf="registerForm.controls.Mobile.errors?.['minlength'] && !registerForm.get('Mobile')?.hasError('dummyMobileNumber')">Minimum
                                        length is 7.</span>
                                    <span class="small text-danger"
                                        *ngIf="registerForm.controls.Mobile.errors && registerForm.get('Mobile')?.hasError('dummyMobileNumber') && !registerForm.controls.Mobile.errors?.['required']">Please
                                        enter a valid mobile number.</span>
                                    <!-- <span class="small text-danger" *ngIf="registerForm.controls.Mobile.invalid && !registerForm.get('Mobile')?.hasError('dummyMobileNumber')">Mobile Number is required.</span> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-12 col-md-12 pe-md-4 ps-md-2 px-0 h-90">
                            <div class="form-floating"
                                [ngClass]="registerForm.controls.CustomerEmail.touched && registerForm.controls.CustomerEmail.errors ? 'mb-1' : 'mb-3'">
                                <input type="email" class="form-control " (paste)="(false)" id="email"
                                    formControlName="CustomerEmail" (input)="emailOnly($event)"
                                    (input)="rmSameEmailError = false" placeholder="Enter Email ID" autocomplete="off">
                                <label for="email">Email <span class="text-danger">*</span></label>
                                <div *ngIf="registerForm.controls.CustomerEmail.touched && registerForm.controls.CustomerEmail.errors"
                                    class="ms-3">
                                    <span class="small text-danger"
                                        *ngIf="!registerForm.controls.CustomerEmail.errors['invalidEmailAddress']">Customer
                                        email is required.</span>
                                    <span class="small text-danger"
                                        *ngIf="registerForm.controls.CustomerEmail.errors['invalidEmailAddress']">Please
                                        provide email in correct format.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
                <!-- <div class="px-md-1  mb-3 d-md-flex row row-cols-auto justify-content-space-around">
                    <div class='row pe-0'>
                        <div class="col-4 px-1">

                            <label class="form-check-label ps-2 fw-mormal" style="font-size: 13px !important;">Choose
                                Account Type :</label>
                        </div>
                        <div class='col-8 px-0 '>
                            <div class="col ">
                                <input class="ms-0 form-check-input" type="radio" name="accountType" [(ngModel)]="NRO"
                                    value="N" id="nri">
                                <label class="form-check-label ps-1 fw-mormal" for="nri"
                                    style="font-size: 12px !important;">Semi Digital - NRE/NRO (Outside India / without
                                    Aadhaar)</label>
                            </div>

                            <div class="col">
                                <input class="ms-lg-0 form-check-input" type="radio" name="accountType"
                                    [(ngModel)]="NRO" value="Y" id="nro">
                                <label class="form-check-label ps-1 fw-mormal" for="nro"
                                    style="font-size: 12px !important;">Fully Digital - NRO (Available only in India
                                    with Aadhaar e-sign)</label>
                            </div>
                        </div>
                    </div>

                </div> -->
                <div class="mb-3">
                    <label class="fw-bold mb-2 d-block" style="font-size:13px;">
                        Choose Account Type :
                    </label>

                    <div class="form-check mb-2 mx-3">
                        <input class="form-check-input" type="radio" name="accountType" [(ngModel)]="NRO" value="N"
                            id="nri" />
                        <label class="form-check-label" for="nri" style="font-size:12px;">
                            Semi Digital - NRE/NRO (Outside India / without Aadhaar)
                        </label>
                    </div>

                    <div class="form-check mx-3">
                        <input class="form-check-input" type="radio" name="accountType" [(ngModel)]="NRO" value="Y"
                            id="nro" />
                        <label class="form-check-label" for="nro" style="font-size:12px;">
                            Fully Digital - NRO (Available only in India with Aadhaar e-sign)
                        </label>
                    </div>
                </div>

                <div class="px-md-3 row mx-0">
                    <div class="col-1 px-0">
                        <input class="form-check-input" [(ngModel)]="terms" [disabled]="rmchekbox" type="checkbox"
                            value="" id="terms" (click)="termsConditions(terms)">
                    </div>
                    <div class="col-11 px-0">
                        <label class="form-check-label ms-1" style="font-size: 12px !important;" for="terms">
                            By submitting this, I accept all the <span class="text-gradient"><a (click)="TandC('terms')"
                                    style="cursor:pointer !important;" class="small text-gradient">Terms &
                                    Conditions</a> </span> <span> & also confirming that I am not resident of <a
                                    (click)="TandC('fatf')" style="cursor:pointer !important;"
                                    class="small text-gradient">FATF</a> Sanction Country list.</span>
                        </label>
                    </div>
                </div>
                <div class="px-md-3 mt-2 row mx-0">
                    <div class="col-1 px-0">
                        <input class=" form-check-input" [(ngModel)]="rmAssist" [disabled]="rmchekbox || rmApp"
                            type="checkbox" value="" id="arm" (click)="assistClick(rmAssist)">
                    </div>
                    <div class="col-11 px-0">
                        <label class="form-check-label ms-1 small" style="font-size: 12px !important;" for="arm">
                            Are you being assisted by a RM?
                        </label>
                    </div>



                </div>
                <div class="px-md-3 " *ngIf="rmAssist" [@enterAnimation]>
                    <div class="mb-2 mt-3">
                        <div id="rmAuto" class="ng-autocomplete rounded-2 border form-floating mt-3">
                            <ng-autocomplete [data]="rmLists" [searchKeyword]="keyword" (selected)='selectEvent($event)'
                                (inputChanged)='onChangeSearch($event)' [itemTemplate]="itemTemplate"
                                [notFoundTemplate]="notFoundTemplate" [(ngModel)]="rmEmail" [disabled]="rmApp"
                                (inputCleared)="deleteRm(rmEmail)" (closed)="rmidCheck(rmEmail)">
                            </ng-autocomplete>
                            <label [ngClass]="rmEmail ? 'small ps-0 pin-top has-value':'small ps-0'">Employee ID<span
                                    class="text-danger">*</span></label>
                            <ng-template #itemTemplate let-item>
                                <a [innerHTML]="item"></a>
                            </ng-template>

                            <ng-template #notFoundTemplate let-notFound>
                                <div [innerHTML]="notFound"></div>
                            </ng-template>

                        </div>
                        <div *ngIf="rmSameEmailError" class="ms-3 mt-2">
                            <span class="small text-danger">Customer email and RM email can't be same.</span>
                        </div>
                        <div *ngIf="rmEmailEmpty" class="ms-3 mt-2">
                            <span class="small text-danger">Employee ID is required.</span>
                        </div>
                    </div>
                </div>
                <div class="px-3 my-4" *ngIf="otpSection">
                    <div class="input-group rounded-2 border w-lg-50 form-floating mb-3">
                        <input type="password" id="rmotp" (paste)="(false)" [(ngModel)]="emailOTP" maxlength="4"
                            (input)="otpError = false;numericOnly($event)"
                            class="form-control ms-3 my-2 border-top-0 border-start-0 border-bottom-0 border-end-0  pe-0 ps-1 py-0"
                            placeholder="Enter OTP">
                        <span class="px-3 my-2 border border-top-0 border-start-0 border-bottom-0 border-end">
                            <img [src]="showOTP ? './assets/images/mdi_eye.png' : './assets/images/eye.png'"
                                (click)="togglePasswordVisibility()" alt="Toggle OTP Visibility" class="img-fluid">
                        </span>
                        <label for="rmotp">Enter OTP <span class="text-danger">*</span></label>

                        <span class="px-3 py-2" id="otptimer">
                            <count-down (reSendTimer)="reSendOTPStatus($event)" *ngIf="!reSendOTP"></count-down>
                            <span *ngIf="reSendOTP" (click)="genOTP()" class="resend">Re-Send OTP</span>
                        </span>

                    </div>
                    <div class="ms-3 small" *ngIf="!otpError">
                        <small *ngIf="rmAssist">As it is RM initiated journey, OTP triggered to registered RM Email
                            ID</small>
                        <small *ngIf="!rmAssist">OTP triggered to your Email ID</small>
                    </div>
                    <div *ngIf="otpError" class="ms-3 mt-2">
                        <span class="small text-danger">Invalid OTP.</span>
                    </div>
                </div>
                <div class="d-flex mt-md-2 mt-3 text-start px-4 ">
                    <span class="continue text-gradient small" (click)="resumeApp()">Resume Application</span>
                    <!-- <img src="./assets/images/flight.svg" height="24" class="ms-2"> -->
                </div>

                <div class="my-3 text-center px-3">
                    <!--<button class="btn btn-primary  px-5"  (click)="genOTP()">Submit</button>-->
                    <!-- <button class="btn btn-primary  px-5" [disabled]="!registerForm.valid || (rmAssist && !rmEmail) || !countryCode || countryCodeError" *ngIf="!otpSection && !blockApp" (click)="genOTP()">Submit</button> -->
                    <!-- <button class="btn btn-primary  px-5" (click)="genOTP()"
                        [disabled]="!terms || registerForm.invalid">Submit</button> -->
                    <button class="btn btn-primary px-5" (click)="EmailField ? genOTP() : NroSubmit()"
                        [disabled]="!terms ||!newCoun|| registerForm.controls.Mobile.invalid || !NRO || registerForm.controls.CustomerEmail.invalid">
                        Submit
                    </button>

                    <!-- <button class="btn btn-primary  px-5" disabled *ngIf="blockApp">Submit</button> -->
                    <button class="btn btn-primary  px-5"
                        [disabled]="blockApp || !registerForm.valid || emailOTP.length !== 4" *ngIf="otpSection"
                        (click)="validateOTP()">Proceed</button>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="container-fluid px-0 bg-white">
    <div class="row mx-0 py-md-5 py-3">
        <div class="text-center col-lg-12 mt-3">
            <p class="h4 text-primary fw-bold">Invest in India from Anywhere in the World</p>
        </div>
        <div class="text-center col-lg-12 mb-3">
            <p class="mb-0">SBI Securities offers you a seamless way to invest in the Indian stock markets, no matter
                where you are. With our comprehensive</p>
            <p class="mb-0">NRI Demat and Trading account, Non-Resident Indians (NRIs) can trade and manage investments
                effortlessly in Indian equities,</p>
            <p class="mb-0">bonds, IPOs and more.</p>
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-3" *ngIf="!isMobile">
        <div class="text-center col-lg-12 mt-3">
            <p class="h4 text-primary fw-bold">Why Choose SBI Securities?</p>
        </div>
        <div class="text-center col-lg-12 my-3">
            <div class="row mx-0">
                <div class="col" *ngFor="let contents of whyChoose;">
                    <div class="card shadow border-0 card_height1">
                        <div class="card-body">
                            <div class="row mx-0 gap-2">
                                <div class="col-lg-12 text-center">
                                    <img [src]="contents.imageUrl">
                                </div>
                                <div class="col-lg-12 text-center">
                                    <p class="fw-bold">{{contents.title}}</p>
                                </div>
                                <div class="col-lg-12 text-center">
                                    <p>{{contents.description}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-3" *ngIf="isMobile">
        <div class="text-center col-lg-12 mt-3">
            <p class="h4 text-primary fw-bold">Why Choose SBI Securities?</p>
        </div>
        <div class="text-center col-lg-12 my-3 Owl_core">
            <owl-carousel-o [options]="customOptions">
                <ng-container *ngFor="let contents of whyChoose">
                    <ng-template carouselSlide>
                        <div class="card shadow border-0 card_height">
                            <div class="card-body">
                                <div class="row mx-0 gap-3">
                                    <div class="col-lg-12 text-center">
                                        <img [src]="contents.imageUrl" class=" gImage">
                                    </div>
                                    <div class="col-lg-12 text-center">
                                        <p class="fw-bold">{{contents.title}}</p>
                                    </div>
                                    <div class="col-lg-12 text-center">
                                        <p>{{contents.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-3" *ngIf="!isMobile">
        <div class="text-center col-lg-12 mt-3">
            <p class="h4 text-primary fw-bold">Key Features of NRI Demat & Trading Account</p>
        </div>
        <div class="text-center col-lg-12 my-3">
            <div class="row mx-0">
                <div class="col" *ngFor="let contents of keyFeatures;">
                    <div class="card shadow border-0">
                        <div class="card-body card_height">
                            <div class="row mx-0 gap-2">
                                <div class="col-lg-12 text-center">
                                    <img [src]="contents.imageUrl">
                                </div>
                                <div class="col-lg-12 text-center">
                                    <p class="fw-bold">{{contents.title}}</p>
                                </div>
                                <div class="col-lg-12 text-center">
                                    <p>{{contents.description}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row mx-0 py-md-5 py-3" *ngIf="isMobile">
        <div class="text-center col-lg-12 mt-3">
            <p class="h4 text-primary fw-bold">Key Features of NRI Demat & Trading Account</p>
        </div>
        <div class="text-center col-lg-12 my-3 Owl_core">
            <owl-carousel-o [options]="customOptions">
                <ng-container *ngFor="let contents of keyFeatures;">
                    <ng-template carouselSlide>
                        <div class="card shadow card_height border-0">
                            <div class="card-body">
                                <div class="row mx-0 gap-3">
                                    <div class="col-lg-12 text-center">
                                        <img [src]="contents.imageUrl">
                                    </div>
                                    <div class="col-lg-12 text-center">
                                        <p class="fw-bold">{{contents.title}}</p>
                                    </div>
                                    <div class="col-lg-12 text-center">
                                        <p>{{contents.description}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ng-container>
            </owl-carousel-o>
        </div>
    </div>
    <div class="container" *ngIf="!isMobile">
        <div class="row mx-0 py-md-5 py-3" id="desktopTabs">
            <div class="col-lg-12 col-md-12">
                <ul class="nav nav-tabs row mx-0" id="myTab" role="tablist"
                    [ngStyle]="{'background-image': 'url(' + currentBackground + ')'}">
                    <li class="nav-item col-md-3 px-0" role="presentation">
                        <button class="nav-link active p-0 cursor w-100 h-100" id="home-tab" (click)="tabChange('tab1')"
                            data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab"
                            aria-controls="home-tab-pane" aria-selected="true" aria-label="Tab 1">
                            <!-- Optionally, add an icon or leave it empty -->
                            <span class="visually-hidden">Tab 1</span> <!-- For screen readers -->
                        </button>
                    </li>
                    <li class="nav-item col-md-3 px-0 " role="presentation">
                        <button class="nav-link p-0 cursor w-100 h-100" id="profile-tab" (click)="tabChange('tab2')"
                            data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab"
                            aria-controls="profile-tab-pane" aria-selected="false" aria-label="Tab 2">
                            <span class="visually-hidden">Tab 2</span>
                        </button>
                    </li>
                    <li class="nav-item col-md-3 px-0" role="presentation">
                        <button class="nav-link p-0 cursor w-100 h-100" id="contact-tab" (click)="tabChange('tab3')"
                            data-bs-toggle="tab" data-bs-target="#contact-tab-pane" type="button" role="tab"
                            aria-controls="contact-tab-pane" aria-selected="false" aria-label="Tab 3">
                            <span class="visually-hidden">Tab 3</span>
                        </button>
                    </li>
                    <li class="nav-item col-md-3 px-0" role="presentation">
                        <button class="nav-link p-0 w-100 h-100" id="disabled-tab" (click)="tabChange('tab4')"
                            data-bs-toggle="tab" data-bs-target="#disabled-tab-pane" type="button" role="tab"
                            aria-controls="disabled-tab-pane" aria-selected="false" aria-label="Tab 4">
                            <span class="visually-hidden">Tab 4</span>
                        </button>
                    </li>
                </ul>


                <!-- <ul class="nav nav-tabs row mx-0" id="myTab" role="tablist">
                    <li class="nav-item col-md-3 px-0" role="presentation" [ngClass]="{'custom-border' : tab1 }">
                      <button class="nav-link active p-0" id="home-tab" (click)="tabChange('tab1')" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">
                        <div class="position-relative">
                            <img [src]="!tab1 ? '../../assets/images/White1.png' : '../../assets/images/color11.png'" class="gImage img-fluid"> 
                        </div>
                      </button>
                    </li>
                    <li class="nav-item col-md-3 px-0" role="presentation" [ngClass]="{'custom-border-1' : tab2 ,'custom-border' : tab1 && !tab2}">
                      <button class="nav-link p-0" id="profile-tab" data-bs-toggle="tab" (click)="tabChange('tab2')" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">
                        <div class="position-relative">
                            <img [src]="!tab2 ? '../../assets/images/White2.png' : '../../assets/images/color21.png'" class="gImage img-fluid"> 
                        </div>
                      </button>
                    </li>
                    <li class="nav-item col-md-3 px-0" role="presentation" [ngClass]="{'custom-border-2' : tab3 ,'custom-border' : tab1 || tab2 && !tab3}">
                      <button class="nav-link p-0" id="contact-tab" data-bs-toggle="tab" (click)="tabChange('tab3')" data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="contact-tab-pane" aria-selected="false">
                        <div class="position-relative">
                            <img [src]="!tab3 ? '../../assets/images/White3.png' : '../../assets/images/color31.png'" class="gImage img-fluid"> 
                        </div>
                      </button>
                    </li>
                    <li class="nav-item col-md-3 px-0" role="presentation"  [ngClass]="{'custom-border-4-1' : tab4 ,'custom-border-4' : tab1 || tab2 || tab3 && !tab4}">
                      <button class="nav-link p-0" id="disabled-tab" data-bs-toggle="tab" (click)="tabChange('tab4')" data-bs-target="#disabled-tab-pane" type="button" role="tab" aria-controls="disabled-tab-pane" aria-selected="false">
                       <div class="position-relative">
                            <img [src]="!tab4 ? '../../assets/images/White4.png' : '../../assets/images/color41.png'" class="gImage img-fluid ps-1"> 
                        </div> 
                      </button>
                    </li>
                  </ul> -->
                <div class="tab-content row mx-0 pt-4 shadow-sm" id="myTabContent">
                    <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab"
                        tabindex="0">
                        <div class="row mx-0">
                            <div class="col-lg-12 col-md-12">
                                <p class="fw-bold">To open an NRI Demat and Trading Account, you must:</p>
                                <ul>
                                    <li>You have attained NRI status as per FEMA guidelines.</li>
                                    <li>You have an NRE or NRO savings account with State Bank of India (SBI).</li>
                                    <li>You have a valid PAN card and complete KYC documentation.</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                    <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab"
                        tabindex="0">
                        <div class="row mx-0">
                            <div class="col-lg-12 col-md-12">
                                <ul>
                                    <li><strong>Fill the Online Form:</strong>Start your journey by filling out a simple
                                        online application form.</li>
                                    <li><strong>Submit KYC Documents:</strong>Upload necessary documents such as
                                        passport, proof of NRI status, and bank details.</li>
                                    <li><strong>PIS Permission:</strong> Get assistance in obtaining RBI’s PIS approval
                                        for trading.</li>
                                    <li><strong>Start Trading:</strong>Once your account is activated, you’re ready to
                                        trade and invest in the Indian stock markets!</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab"
                        tabindex="0">
                        <div class="row mx-0">
                            <div class="col-lg-12 col-md-12">
                                <ul>
                                    <li>Copy of Valid Passport (with relevant pages showing personal details and
                                        validity)</li>
                                    <li>Valid visa or Resident / Work permit showing current residential status outside
                                        India</li>
                                    <li>Proof of Overseas address (Tenancy Contract, Utility bills etc.)</li>
                                    <li>Indian address proof (as applicable)</li>
                                    <li>Aadhar card (as applicable)</li>
                                    <li>TIN (Tax Identification Number) Proof of Overseas country</li>
                                    <li>Latest 3 months' SBI NRE/NRO Bank Account statement</li>
                                    <li>Two recent passport-sized photographs</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel" aria-labelledby="disabled-tab"
                        tabindex="0">
                        <div class="row mx-0">
                            <div class="col-lg-12 col-md-12">
                                <ul>
                                    <li>All KYC & Bank documents should be self-attested and notarized by authorized
                                        officials.</li>
                                    <li>In-person verification with original seen & verified attestation is mandatory on
                                        your KYC documents</li>
                                    <li><strong>For Face-to-Face Customers (When in India):</strong> KYC documents must
                                        be verified in person with the original attestation by State Bank of India (SBI)
                                        or SBI Securities Limited (SSL) officials.</li>
                                    <li><strong>For Non-Face-to-Face Customers (When Outside India):</strong>KYC
                                        documents must be verified in person with the original attestation by any one of
                                        the following:
                                        <span>
                                            <ul>
                                                <li>SBI Overseas Branch officials (with their SS number)</li>
                                                <li>Existing bankers</li>
                                                <li>Authorized officials of overseas branches of Scheduled Commercial
                                                    Banks registered in India</li>
                                                <li>Notary Public, Court, Magistrate, Judge</li>
                                                <li>Indian Embassy/Consulate General in the country where you reside
                                                    (with relevant details of such officials)  </li>
                                                <li>KYC documents in any language other than English or Hindi must be
                                                    translated into English by a certified translator/interpreter; or an
                                                    official of the Embassy of the Country where the document is issued.
                                                </li>
                                            </ul>
                                        </span>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container my-3" id="mobileTabs" *ngIf="isMobile">
        <nav>
            <div class="nav nav-tabs custom-border-4" id="nav-tab" role="tablist">
                <button class="nav-link active px-1" id="nav-home-tab" data-bs-toggle="tab"
                    data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="nav-home"
                    aria-selected="true">Eligibility Criteria</button>
                <button class="nav-link px-1" id="nav-profile-tab" data-bs-toggle="tab"
                    data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="nav-profile"
                    aria-selected="false">How to Get Started</button>
                <button class="nav-link px-1" id="nav-contact-tab" data-bs-toggle="tab"
                    data-bs-target="#contact-tab-pane" type="button" role="tab" aria-controls="nav-contact"
                    aria-selected="false">KYC Documents required</button>
                <button class="nav-link px-1" id="nav-disabled-tab" data-bs-toggle="tab"
                    data-bs-target="#disabled-tab-pane" type="button" role="tab" aria-controls="nav-disabled"
                    aria-selected="false">Important Points to Note</button>
            </div>
        </nav>
        <div class="tab-content row mx-0 pt-4 shadow-sm" id="myTabContent">
            <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab"
                tabindex="0">
                <div class="row mx-0">
                    <div class="col-lg-12 col-md-12">
                        <p class="fw-bold">To open an NRI Demat and Trading Account, you must:</p>
                        <ul>
                            <li>You have attained NRI status as per FEMA guidelines.</li>
                            <li>You have an NRE or NRO savings account with State Bank of India (SBI).</li>
                            <li>You have a valid PAN card and complete KYC documentation.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
                <div class="row mx-0">
                    <div class="col-lg-12 col-md-12">
                        <ul>
                            <li><strong>Fill the Online Form:</strong>Start your journey by filling out a simple online
                                application form.</li>
                            <li><strong>Submit KYC Documents:</strong>Upload necessary documents such as passport, proof
                                of NRI status, and bank details.</li>
                            <li><strong>PIS Permission:</strong> Get assistance in obtaining RBI’s PIS approval for
                                trading.</li>
                            <li><strong>Start Trading:</strong>Once your account is activated, you’re ready to trade and
                                invest in the Indian stock markets!</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="contact-tab-pane" role="tabpanel" aria-labelledby="contact-tab" tabindex="0">
                <div class="row mx-0">
                    <div class="col-lg-12 col-md-12">
                        <ul>
                            <li>Copy of Valid Passport (with relevant pages showing personal details and validity)</li>
                            <li>Valid visa or Resident / Work permit showing current residential status outside India
                            </li>
                            <li>Proof of Overseas address (Tenancy Contract, Utility bills etc.)</li>
                            <li>Indian address proof (as applicable)</li>
                            <li>Aadhar card (as applicable)</li>
                            <li>TIN (Tax Identification Number) Proof of Overseas country</li>
                            <li>Latest 3 months' SBI NRE/NRO Bank Account statement</li>
                            <li>Two recent passport-sized photographs</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel" aria-labelledby="disabled-tab"
                tabindex="0">
                <div class="row mx-0">
                    <div class="col-lg-12 col-md-12">
                        <ul>
                            <li>All KYC & Bank documents should be self-attested and notarized by authorized officials.
                            </li>
                            <li>In-person verification with original seen & verified attestation is mandatory on your
                                KYC documents</li>
                            <li><strong>For Face-to-Face Customers (When in India):</strong> KYC documents must be
                                verified in person with the original attestation by State Bank of India (SBI) or SBI
                                Securities Limited (SSL) officials.</li>
                            <li><strong>For Non-Face-to-Face Customers (When Outside India):</strong>KYC documents must
                                be verified in person with the original attestation by any one of the following:
                                <span>
                                    <ul>
                                        <li>SBI Overseas Branch officials (with their SS number)</li>
                                        <li>Existing bankers</li>
                                        <li>Authorized officials of overseas branches of Scheduled Commercial Banks
                                            registered in India</li>
                                        <li>Notary Public, Court, Magistrate, Judge</li>
                                        <li>Indian Embassy/Consulate General in the country where you reside (with
                                            relevant details of such officials)  </li>
                                        <li>KYC documents in any language other than English or Hindi must be translated
                                            into English by a certified translator/interpreter; or an official of the
                                            Embassy of the Country where the document is issued.</li>
                                    </ul>
                                </span>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row mx-0  py-3">
            <div class="col-lg-12 col-md-12 px-5 text-md-start text-center">
                <p>Once you have these documents ready, you can proceed with the application process.</p>
                <a class="f-18 fw-bold" href="tel:+912268567464">Need Help?</a>
                <p class="mt-4">Our dedicated NRI Services team is here to assist you at every step. Whether you need
                    help with documentation or have queries about the account opening process, we’ve got you covered.
                </p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row mx-0 ">
            <div class="text-center col-lg-12 mt-3">
                <p class="h4  fw-bold text-gradient">Invest Smart. Invest Globally. Start Your Journey with SBI
                    Securities Today</p>
            </div>
            <div class="text-center col-lg-12 mt-3 bg_gradient p-md-3 p-4">
                <p class="mb-0"><a class="text-white" href="mailto:NRIDESK.SSL@sbicapsec.com">E-mail:
                        NRIDESK.SSL&#64;sbicapsec.com </a> | Call us: +91 2268567464</p>
                <p class="mb-0 mt-md-2">Product Offerings: Equity I 54 EC Bonds I IPO I Corporate FDs I Insurance I IPO
                    I  <a class="text-white" href="https://app.sbisecurities.in/loans/car-loan" target="_blank">Car
                        Loan*</a>I  <a class="text-white" href="https://app.sbisecurities.in/loans/home-loan"
                        target="_blank">Home Loan*</a></p>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row mx-0 py-md-5 py-3">
            <div class="col-lg-12 col-md-12 px-md-5 d-flex">
                <p><span class="fw-bold">Disclaimer:</span>The NRI Demat and Trading account is subject to FEMA and RBI
                    regulations. Please consult your financial advisor for personalized advice.</p>

            </div>
        </div>
    </div>
    <div class="container">
        <div class="row mx-0">
            <div class="col-12 my-3" *ngIf="isMobile">
                <img src="./assets/images/sbiheader.png" class="img-fluid">
            </div>
            <div class="col-lg-2 col-6 order-0 my-3 my-md-0 order-md-0">
                <h5 class="fw-bold">Quick Links</h5>
                <p>About Us</p>
                <p>CSR</p>
                <p>Platforms</p>
                <p>Holiday Calendar</p>
            </div>
            <div class="col-lg-2 col-6 order-1 my-3 my-md-0 order-md-0">
                <h5 class="fw-bold">Login</h5>
                <p>Trade Login</p>
                <p>DP Login</p>
                <p>NRI Zone</p>
            </div>
            <div class="col-lg-4 order-4 my-3 my-md-0 order-md-0">
                <h5 class="fw-bold">Important Communication</h5>
                <p>Request for Approval</p>
                <p>Disclosures</p>
                <p>Announcements</p>

            </div>
            <div class="col-lg-4 order-6 my-3 my-md-0 order-md-0 " *ngIf="isMobile">
                <h5 class="fw-bold">Stay Connected:</h5>
                <div class="d-flex gap-3">
                    <a href="https://www.facebook.com/sbisecurities" target="_blank">
                        <img src="./assets/images/FB.png" class="img-fluid gImage" alt="google">
                    </a>
                    <a href="https://twitter.com/_sbisecurities" target="_blank">
                        <img src="./assets/images/twieet.png" class="gImage img-fluid" alt="google">
                    </a>
                    <a href="https://in.linkedin.com/company/sbisecurities" target="_blank">
                        <img src="./assets/images/linkedin.png" class="gImage img-fluid" alt="google">
                    </a>
                    <a href="https://www.instagram.com/sbisecurities/" target="_blank">
                        <img src="./assets/images/instagram.png" class="gImage img-fluid" alt="google">
                    </a>
                    <a href="https://youtube.com/channel/UCpAG_iCjKJ8BK8YHgn9cxCQ" target="_blank">
                        <img src="./assets/images/youtube.png" class="gImage img-fluid" alt="google">
                    </a>
                </div>
            </div>
            <div class="col-lg-4 order-7 my-3 my-md-0 order-md-0" *ngIf="!isMobile">
                <h5 class="fw-bold">Our Apps</h5>
                <div class="d-flex gap-1">
                    <a href="https://www.sbisecurities.in/android" target="_blank">
                        <img src="./assets/images/googleplay.png" class="gImage" alt="google">
                    </a>
                    <a href="https://www.sbisecurities.in/ios" target="_blank">
                        <img src="./assets/images/appstore.png" class="gImage" alt="google">
                    </a>
                </div>
            </div>
            <!-- </div>
        <div class="row"> -->
            <div class="col-lg-2 col-6 order-2 my-3 my-md-0 order-md-0">
                <h5 class="fw-bold">Knowledge Centre</h5>
                <p>Blog</p>
            </div>
            <div class="col-lg-2 col-6 order-3 my-3 my-md-0 order-md-0">
                <h5 class="fw-bold">Useful Links</h5>
                <p>Careers</p>
                <p>Downloads</p>
                <p>Contact Us</p>
                <p>Recovery Module</p>
                <p>Block Online Access</p>
            </div>
            <div class="col-lg-4 order-5 my-3 my-md-0 order-md-0">
                <h5 class="fw-bold">Where we are</h5>
                <p>Marathon Futurex, B-wing, 12th Floor,</p>
                <p>Lower Parel East, Mumbai - 400013</p>
                <p> <a href="tel:+91 022 6854 5555" class="text-black">022 6854 5555</a> </p>
                <p> <a href="mailto:helpdesk@sbicapsec.com" class="text-black"> helpdesk&#64;sbicapsec.com</a> </p>
            </div>
            <div class="col-lg-4 order-5 my-3 my-md-0 order-md-0" *ngIf="isMobile">
                <h5 class="fw-bold">Our Apps</h5>
                <div class="d-flex gap-1">
                    <a href="https://www.sbisecurities.in/android" target="_blank">
                        <img src="./assets/images/googleplay.png" class="gImage" alt="google">
                    </a>
                    <a href="https://www.sbisecurities.in/ios" target="_blank">
                        <img src="./assets/images/appstore.png" class="gImage" alt="google">
                    </a>
                </div>
            </div>
            <div class="col-lg-4 order-6 my-3 my-md-0 order-md-0 " *ngIf="!isMobile">
                <h5 class="fw-bold">Stay Connected:</h5>
                <div class="d-flex gap-3">
                    <a href="https://www.facebook.com/sbisecurities" target="_blank">
                        <img src="./assets/images/FB.png" class="img-fluid gImage" alt="google">
                    </a>
                    <a href="https://twitter.com/_sbisecurities" target="_blank">
                        <img src="./assets/images/twieet.png" class="gImage img-fluid" alt="google">
                    </a>
                    <a href="https://in.linkedin.com/company/sbisecurities" target="_blank">
                        <img src="./assets/images/linkedin.png" class="gImage img-fluid" alt="google">
                    </a>
                    <a href="https://www.instagram.com/sbisecurities/" target="_blank">
                        <img src="./assets/images/instagram.png" class="gImage img-fluid" alt="google">
                    </a>
                    <a href="https://youtube.com/channel/UCpAG_iCjKJ8BK8YHgn9cxCQ" target="_blank">
                        <img src="./assets/images/youtube.png" class="gImage img-fluid" alt="google">
                    </a>
                </div>
            </div>
        </div>
    </div>
    <div class="container d-none d-md-block">
        <div class="row mx-0 ">
            <div class="col-lg-12 col-md-12 px-md-5 text-center">
                <p class="fw-bold mb-0">SBICAP Securities Limited</p>
                <p class="mb-0">AMFI Registered Mutual Fund Distributor</p>
                <p class="mb-0">CIN: U65999MH2005PLC155485</p>
            </div>
        </div>
    </div>
    <div class="container mt-4">
        <div class="col-md-12 row justify-content-center bg-white m-0">
            <div class="col-md-12 mb-5  ml-5 mr-5 text-center">
                <p class="mb-0 text-center"><small>
                        Equities: Trading through SBICAP Securities Limited I Website: www.sbisecurities.in SEBI
                        Registration No.: Stock Broker: INZ000200032 | DP Registration No.: IN-DP-314-2017 | Research
                        Analyst : INH000000602 | IRDAI Corporate Agency Reg. No. CA0103; AMFI Reg. No. ARN-0011 (Date of
                        initial registration: 19th August 2005 and valid upto 18th February 2027); PFRDA Reg. No.
                        POP26092018. In case of any grievances please write to complaints&#64;sbicapsec.com DP related
                        grievance can be sent to :dp.grievance&#64;sbicapsec.com | NPS related grievance can be sent to
                        : Npsgrievance&#64;sbicapsec.com | Compliance officer – Mr. Rajiv Kejriwal , email
                        -compliance&#64;sbicapsec.com; Tel No.- 022 – 69316510</small></p>
                <p class="mb-0 text-center"><small>SBICAP Securities Limited is authorized by the Insurance Regulatory
                        and Development Authority of India to act as a Corporate Agent from 01- April- 2022 to 31-March
                        2025 for procuring or soliciting insurance business of Life, General and Health under license
                        number CA0103, Category: Composite. SBICAP Securities Ltd. does not underwrite the risk or act
                        as an insurer. The advertisement contains only an indication of the cover offered. For more
                        details on risk factors, terms, conditions and exclusions, please read the sales brochure
                        carefully before concluding a sale. SBI Logo displayed belongs to State Bank of India and used
                        by SBICAP Securities Limited under license. Personal information as submitted by you will be
                        shared with SBICAP and insurer in order to complete your application. By continuing, you provide
                        your consent for the above and authorize SBICAP Securities representatives to contact you
                        through call, SMS, WhatsApp or E-mail for providing assistance towards the application process.
                    </small></p>
                <p class="mb-0 text-center"><small>
                        BEWARE OF SPURIOUS PHONE CALLS AND FICTITIOUS /FRAUDULENT OFFERSIRDAI is not involved in
                        activities like selling insurance policies, announcing bonus or investment of premiums. Public
                        receiving such phone calls are requested to lodge a police complaint. To read more, please click
                        here - <a class="f-11 linkre text-dark"
                            href="https://www.sbisecurities.in/fileserver/pdf/compliance/IRDAI%20Public%20notice.pdf"
                            target="_blank"> IRDAI Public Notice </a></small></p>
                <p class="mb-0 text-center">
                    <small>Copyright © 2024. All rights Reserved.<a class="text-dark"
                            href="https://www.sbisecurities.in/" target="_blank"> SBICAP Securities
                            Limited.</a>Limited.Site is best viewed in edge browser, Firefox 38+, Chrome 50+ at 1366x768
                        pixel resolution. Windows 10 and above.</small>
                </p>
            </div>
        </div>
    </div>
    <div class="mt-10 line-class w-100 mb-1"></div>
    <div class="col-md-12 row justify-content-center bg-white m-0">
        <div class="col-md-12 mb-3 mt-3 ml-5 mr-5">
            <p class="mb-3 f-12 text-center"><a class="f-11 linkre text-dark"
                    href="https://www.sbisecurities.in/investor-charter" target="_blank">Investor Charter </a>|<a
                    class="f-11 linkre text-dark" href="https://www.sbisecurities.in/investor-awareness"
                    target="_blank"> Investor Awareness </a>|
                <a class="f-11 linkre text-dark" href="https://www.sbisecurities.in/security-tips" target="_blank">
                    Security tips </a>| <a class="f-11 linkre text-dark" href="https://www.sbisecurities.in/disclaimer"
                    target="_blank"> Disclaimer </a>|
                <a class="f-11 linkre text-dark" href="https://www.sbisecurities.in/fileserver/pdf/Privacy-Policy.pdf"
                    target="_blank"> Privacy Policy </a>| <a class="f-11 linkre text-dark"
                    href="https://www.sbisecurities.in/fileserver/pdf/Cookies-Policy.pdf" target="_blank">Cookies Policy
                </a>|
                <a class="f-11 linkre text-dark" href="https://www.sbisecurities.in/terms" target="_blank">Terms &
                    Conditions </a>|<a class="f-11 linkre text-dark"
                    href="https://www.scores.gov.in/scores/Welcome.html" target="_blank"> SCORES </a>| <a
                    class="f-11 linkre text-dark" href="https://smartodr.in/intermediary/login" target="_blank">Online
                    Resolution of Disputes (ODR)</a>| <a class="f-11 linkre text-dark"
                    href="https://www.sbisecurities.in/fileserver/pdf/compliance/DND%20Policy.pdf" target="_blank">DND
                    Policy</a>
            </p>

        </div>
    </div>

</div>
<div class="modal" id="resumeModals" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-fullscreen modal-dialog-centered">
        <div class="modal-content">
            <!-- <div class="modal-header border-0 px-4">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div> -->
            <div class="modal-body p-md-0">
                <nav class="navbar bg-white h-84 shadow-sm" *ngIf="!isMobile">
                    <div class="container-fluid">
                        <a class="navbar-brand ps-md-5">
                            <img src="./assets/images/sbiheader.png" alt="Logo" class="img-fluid">
                        </a>
                    </div>
                </nav>
                <div class="row mx-0  register">
                    <div class="col-md-8 text-center" [ngClass]="isMobile ? 'mob' : ''">
                        <!-- <img src="./assets/images/Axis-Direct-Logo-ffffff@2x.png" class="mt-md-5 mt-4 img-fluid" width="auto" /> -->
                        <div class="d-flex align-items-center h-md-50 w-md-100 w-75">
                            <div class="text-white flex-fill text-start mt-md-4 mt-3 ">
                                <h1 class="mt-md-5 px-md-5 px-3 fw-bold  clrtxt"> Go Global on Investments </h1>
                                <h1 class="fw-normal px-md-5 px-3 clrtxt"> with your </h1>
                                <h1 class="px-md-5 px-3 fw-bold  clrtxt"> NRI Demat & Trading Account</h1>
                            </div>
                        </div>

                    </div>
                    <div class="col-md-4 my-1 py-md-5 d-flex justify-content-center">
                        <div class="card resume-screen ml-auto  mt-md-5 me-md-5 shadow-sm border-0">
                            <div class="card-body">
                                <div class="row">
                                    <button type="button" class="btn-close ms-auto me-3" data-bs-dismiss="modal"
                                        aria-label="Close"></button>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-12 text-center">
                                        <p class="text-gradient fw-bold">Open Your NRI Demat & Trading Account Now !</p>
                                    </div>
                                </div>
                                <div class="row" *ngIf="!resumeOTPArea">
                                    <div class="col-md-12 text-center">
                                        <p class="text-gradient fw-bold mb-1">Resume Application Status</p>
                                    </div>
                                    <div class="col-md-12 text-center mb-2">
                                        <small class="fw-bold">Please enter PAN and validate OTP to Resume your
                                            journey.</small>
                                    </div>
                                    <!-- <div class="col-md-2"></div> -->
                                    <div class="col-md-12 px-md-4 my-2">
                                        <div class="form-floating">
                                            <input class="form-control  text-uppercase" type="text"
                                                placeholder="Enter PAN" #resumeInput id="resume-pan"
                                                [(ngModel)]="resumePan"
                                                (input)="resumePanError = false;onPanChange($event)" maxlength="10"
                                                autocomplete="off" />
                                            <label for="resume-pan">Enter your Registered PAN <span
                                                    class="text-danger">*</span></label>
                                        </div>
                                        <div *ngIf="resumePanError" class="">
                                            <span class="small text-danger">Please Enter Valid PAN</span>
                                        </div>
                                    </div>
                                    <!-- <div class="col-md-2"></div> -->
                                    <div class="col-md-12 text-center my-2">
                                        <button type="button" class="btn btn-primary  px-4" (click)="panResumeVal()">
                                            Generate OTP
                                        </button>
                                    </div>
                                </div>

                                <div class="row mx-0" *ngIf="resumeOTPArea">
                                    <div class="col-md-12 text-center">
                                        <p class="text-gradient fw-bold">Resume Application Status</p>
                                    </div>
                                    <div class="col-md-12 text-center mb-2">
                                        <small class="fw-bold">Confirm the 4-digit OTP sent to the Email
                                            address.</small>
                                    </div>
                                    <div class="col-md-12 text-center">
                                        <ng-otp-input class="my-4" #ngOtpInput (onInputChange)="resumeotp($event)"
                                            [config]="config"></ng-otp-input>
                                    </div>
                                    <div class="col-md-12 text-end mt-md-2 pe-md-5">
                                        <div class="row">
                                            <div *ngIf="otpResumeError" class="col-7">
                                                <span class="small text-danger"
                                                    style="font-size: 0.75rem !important;">Please enter Valid
                                                    OTP.</span>
                                            </div>
                                            <div class="text-end" [ngClass]="otpResumeError ? 'col-5' : 'col-12'">
                                                <span class="px-3 py-2" id="otptimer">
                                                    <count-down class="text-primary"
                                                        (reSendTimer)="reSendOTPStatus($event)"
                                                        *ngIf="!reSendOTP && timer"></count-down>
                                                    <span *ngIf="reSendOTP" (click)="panResumeVal()"
                                                        class="small text-primary">Re-Send OTP</span>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-12 text-center my-2">
                                        <button type="button" class="btn btn-primary  px-4" (click)="resumeOTPVal()">
                                            Validate
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="panModal" tabindex="-1" aria-labelledby="modalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" [ngClass]="existingDemat? 'modal-lg': ''">
        <div class="modal-content">
            <div class="modal-header border-0 mb-0 pb-0 px-4">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="panResumeNo()"></button>
            </div>
            <div class="modal-body px-md-5 py-md-4 p-4">
                <div *ngIf="refExists">
                    <p class="normal">An application with this PAN already exists. Resume Journey?</p>
                    <p class="normal">
                        <button type="button" class="btn btn-primary  px-4 normal" data-bs-dismiss="modal"
                            (click)="panResumeYes()">
                            Yes
                        </button>
                        <button type="button" class="ms-md-4 ms-2 btn btn-primary  px-4 normal" data-bs-dismiss="modal"
                            (click)="panResumeNo()">
                            No
                        </button>
                    </p>
                </div>
                <div *ngIf="ri">
                    <p class="normal">
                        You already have an existing account with us. Would you like to close your existing account and
                        proceed with opening a NRI account?
                    </p>
                    <p class="normal mt-4">
                        <button type="button" class="btn btn-primary  px-4 normal" (click)="riResumeYes()">
                            Yes, proceed
                        </button>
                        <button type="button" class="ms-4 btn btn-primary  px-4 normal" (click)="panResumeNo()">
                            Not at the moment
                        </button>
                    </p>
                </div>
                <div *ngIf="existingDemat">
                    <p class="normal">
                        You already have a NRI trading and demat account with us. If you decide to continue regardless,
                        we will only able to open the remaining sub-accounts and not modify/update any of the existing
                        accounts.
                    </p>

                    <div class="row">
                        <div class="col-lg-6 normal my-4">
                            Existing Sub-Accounts:
                            <ul>
                                <li *ngIf="!nre_pis" class="me-2 normal">NRE PIS : {{nre_pisno}}</li>
                                <li *ngIf="!nre_nonpis" class="me-2 normal">NRE NPIS : {{nre_nonpisno}}</li>
                                <li *ngIf="!nro_pis" class="me-2 normal">NRO PIS : {{nro_pisno}}</li>
                                <li *ngIf="!nro_nonpis" class="me-2 normal">NRO NPIS : {{nro_nonpisno}}</li>
                            </ul>
                        </div>

                        <div class="col -md-6 normal my-4">
                            Sub-Accounts that can be opened:
                            <ul>
                                <li *ngIf="nre_pis" class="me-2 normal">NRE PIS</li>
                                <li *ngIf="nre_nonpis" class="me-2 normal">NRE NPIS</li>
                                <li *ngIf="nro_pis" class="me-2 normal">NRO PIS</li>
                                <li *ngIf="nro_nonpis" class="me-2 normal">NRO NPIS</li>
                            </ul>
                        </div>
                    </div>

                    <p class="normal mt-4">
                        <button type="button" class="btn btn-primary  px-4 normal" (click)="riResumeYes()">
                            Yes, proceed
                        </button>
                        <button type="button" class="ms-md-4 ms-0 mt-md-0 mt-4 btn btn-primary  px-4 normal"
                            (click)="panResumeNo()">
                            Not at the moment
                        </button>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header px-4">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Welcome To SBI Securities Family</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="completed()"></button>
            </div>
            <div class="modal-body">
                We have received, your request for opening account online. It is under process as of now.
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary  px-4" data-bs-dismiss="modal"
                    (click)="completed()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="dbError" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header px-4">
                <h1 class="modal-title fs-5" id="exampleModalLabel">Welcome To SBI Securities Family</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                    (click)="completed()"></button>
            </div>
            <div class="modal-body">
                <p class="m-0">{{errorMessage}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary  px-4" data-bs-dismiss="modal"
                    (click)="completed()">Close</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="otpModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <!-- <div class="modal-header px-4 border-0">
        </div> -->
            <div class="modal-body">
                <div class="row">
                    <div class="col-md-12 text-end">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            (click)="otpClear()"></button>
                    </div>
                </div>
                <div class="col-md-12 text-center">
                    <p class="text-gradient text-center h6 fw-bold mb-3" id="exampleModalLabel">
                        {{ EmailField ? 'Email OTP Verification' : 'Mobile OTP Verification' }}
                    </p>
                </div>
                <div class="col-md-12 text-center">
                    <p class="text-center small fw-bold">
                        {{
                        EmailField? 'Enter the OTP sent to your registered email ID': (newCoun === '91'
                        ? 'An OTP (One-Time Password) will be sent to the mobile number you provided on SMS. Make sure
                        your phone is nearby and active so you can receive the OTP without delays.'
                        : 'An OTP (One-Time Password) will be sent to the mobile number you provided on WhatsApp. Make
                        sure your phone is nearby and active so you can receive the OTP without delays.')
                        }}
                    </p>
                </div>
                <div class="row mx-0">
                    <div class="col-md-12 text-center">
                        <ng-otp-input class="my-4" #ngOtpInput (onInputChange)="onOtpChange($event)"
                            [config]="config"></ng-otp-input>
                    </div>
                    <div class="col-md-12 text-end mt-md-2 pe-md-5">
                        <span class="px-3 py-2" id="otptimer">
                            <count-down class="text-primary" (reSendTimer)="reSendOTPStatus($event)"
                                *ngIf="!reSendOTP && timer"></count-down>
                            <span *ngIf="reSendOTP" (click)="EmailField ? genOTP() : MobgenOTP()"
                                class="small text-primary"> Re-Send OTP
                            </span> </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer border-0 justify-content-center">
                <button type="button" class="btn btn-primary normal px-4"
                    (click)="EmailField ? validateOTP() : validateMobileOTP()">
                    CONFIRM OTP
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Google Modal -->


<div class="modal fade" id="googleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog  modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row text-center">
                    <div class="col-md-12">
                        <img src="./assets/images/googleImg.png" class="gImage" alt="google" width="80" height="auto">
                    </div>
                    <div class="col-md-12 mt-3">
                        <strong>Continue to verify your EmailID with Google Account?</strong>
                    </div>
                </div>
            </div>
            <div class="modal-footer row mx-0">
                <div class="col-12 m-0 mt-0">
                    <button type="button" class="btn btn-primary px-4 fw-bold w-100 py-2 text-uppercase"
                        data-bs-dismiss="modal" (click)="redirGoogle()">Yes, Continue with google</button>
                </div>
                <div class="col-12 mt-2">
                    <button type="button" class="btn btn-google px-4 fw-bold w-100 py-2" data-bs-dismiss="modal"
                        (click)="manuallyemail()">No, Enter Email manually</button>
                </div>

            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="NROPop" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body">
                <div class="row text-center">
                    <div class="col-md-12">
                        <strong class="text-gradient">Are you sure to proceed your journey with?</strong>
                    </div>
                    <div class="px-md-2 px-0 mb-3">
                        <!--  <strong>Account Type <span class="text-danger">*</span></strong>-->
                        <div class="mt-4 d-md-flex row row-cols-auto justify-content-center">
                            <div class="col">
                                <input class="ms-0 form-check-input" type="radio" name="NRO" [(ngModel)]="NRO" value="N"
                                    id="nri">
                                <label class="form-check-label ps-2" for="nri">NRI</label>
                            </div>

                            <div class="col">
                                <input class="ms-lg-3 form-check-input" type="radio" name="NRO" [(ngModel)]="NRO"
                                    value="Y" id="nro">
                                <label class="form-check-label ps-2" for="nro">NRO</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer row mx-0">

                <div class="col-12 m-0 mt-2">
                    <button type="button" class="btn btn-primary normal px-4  w-100 py-2" data-bs-dismiss="modal"
                        (click)="NroSubmit()" [disabled]="!NRO">Proceed</button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="tandcPopup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" [ngClass]="fatf ? 'modal-md' : 'modal-lg'">
        <div class="modal-content">
            <div class="modal-header border-0 px-4" *ngIf="fatf">
                <h1 class="modal-title text-gradient fs-5" id="exampleModalLabel">FATF Countries</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body" *ngIf="!fatf">
                <div class="d-flex p-3">
                    <button type="button" class="btn-close ms-auto" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="row mx-0">
                    <div class="col-md-12">
                        <p class="h3"><strong>Demat & Trading Preferences</strong></p>
                    </div>

                    <div class="col-md-12 my-3">
                        <ul>
                            <li>I understand and agree that the nature of information I have provided for the purpose of
                                Account Opening with / through SBICAP Securities Limited (SSL) (hereinafter referred as
                                “the Company”) which may be used to query my details in KRA databases as well as to
                                fetch
                                my information from KRA databases.</li>
                            <li>I am aware and agree to open NRI Demat and Trading account opened.</li>
                            <li>I am aware about RBI and FEMA guidelines for trade in INDIA.</li>
                            <li>I will have to submit the physical account opening / modification form.</li>
                            <li>I am aware and agree that my Trading and Demat account will be opened as per the name
                                available in the Income tax database.</li>
                            <li>I hereby consent the company to provide its communication on my registered phone
                                number(s) & email Id as available with the Company.</li>
                            <li>I confirm my consent to share my email id with the RTA (Registrar and Transfer Agency).
                            </li>
                            <li>I hereby consent to receive all statements of accounts, statements of holding, contract
                                notes,
                                consolidated statements, transaction statements and annual reports in electronic form
                                from
                                the company.</li>
                            <li>I hereby consent to receiving information from Central KYC Registry/Email on the above
                                registered number/email address and to download my records
                                from CKYCR.</li>
                            <li>I hereby confirm to avail the Email alert facility in my Demat and Trading account.</li>
                            <li>I hereby confirm that I have not opted for DIS booklet at the time of Account opening .
                            </li>
                            <li>I hereby confirm to receive credit of shares and securities without my consent in my
                                Demat
                                account.</li>
                            <li>I hereby confirm to accept all pledge instructions in my Demat account without any
                                further
                                instruction from my end.</li>
                            <li>I hereby consent that by submitting my application for NRI demat and trading account
                                online, Demat Debit and Pledge Instruction (DDPI) will be enabled Equity & Mutual Funds.
                            </li>
                            <li>Transfer of securities held in the beneficial owner accounts of the client towards Stock
                                Exchange related deliveries / settlement obligations arising out of trades executed by
                                clients
                                on the Stock Exchange through the same stockbroker.</li>
                            <li>Pledging / re-pledging of securities in favor of trading member (TM) / clearing member
                                (CM) for the purpose of meeting margin requirements of the clients in connection with
                                the
                                trades executed by the clients on the Stock Exchange.</li>
                            <li>Tendering shares in open offers through Stock Exchange platforms.</li>
                            <li>I confirm to avail of the facility of internet trading using wireless technology.</li>
                        </ul>
                    </div>
                    <div class="col-md-12 my-3">
                        <p class="h3"><strong>Declarations</strong></p>
                    </div>
                    <div class="col-md-12">
                        <ul>
                            <li>I declare and agree that the signature and photograph provided by me, belongs to me, for
                                opening a Demat and trading account with SBICAP Securities Limited (hereinafter referred
                                as “the Company”)</li>
                            <li>I declare that by submitting the contact details by me, I authorize SBICAP Securities
                                Limited
                                to contact me and send promotional communication, even though I may be registered under
                                National Do Not Call Registry established under the Telecom Unsolicited Commercial
                                Communications Regulations, 2007 or registered or may register under the National
                                Customer Preference Register established under the new regulation viz. The Telecom
                                Commercial Communications Customer Preference Regulations, 2010. And I don't hold the
                                Company responsible for the aforesaid act.</li>
                            <li>I hereby declare that the rules and regulations of the Depository and Depository
                                Participant
                                to an account which are in force now have been read by me and I have understood the same
                                and I agree to abide by and to be bound by the rules as are in force from time to time
                                for
                                such account.</li>
                            <li>I hereby declare that the details furnished are true and correct to the best of my
                                knowledge
                                and belief and I undertake to inform you of any changes therein, immediately. In case
                                any of
                                the above information is found to be false or untrue or misleading or misrepresenting, I
                                am
                                aware that I may be held liable for it.</li>
                            <!-- <p><strong>Note: </strong>Disclosure as to Proprietary Trades by SSL: SSL may carry out
                                proprietary trades in addition to trades on behalf of its Clients.</p> -->
                        </ul>
                    </div>
                    <div class="col-md-12 my-3">
                        <p class="h3"><strong>General Terms & Conditions</strong></p>
                    </div>
                    <div class="col-md-12">
                        <ul>
                            <li> <strong> Email Statement: </strong>I understand that the email statements are for my
                                convenience. SSL shall
                                not be liable or responsible for any breach of secrecy because the statements are being
                                sent
                                to the email ID registered with it. I shall verify the authenticity of the emails I
                                receive. I shall
                                not hold the Company responsible for any statement received from fraudsters/imposters. I
                                shall not hold the company liable if any problem arises with my computer network because
                                of me receiving statements from the company. The Company shall not be responsible if
                                I/we
                                do not receive a statement due to incorrect email address and technical reasons. I will
                                take
                                all the necessary steps to maintain and ensure confidentiality and secrecy of the login
                                name
                                and password of the internet/email account. I shall inform the Company in writing if
                                there
                                is any change in the email address.</li>
                            <li> <strong> FATCA:</strong> I have understood the information requirements of FATCA Form
                                as per the CBDT
                                notified Rules 114F to 114H and hereby confirm that the information provided by me on
                                this Form is true, correct, and complete. I also confirm that I have read and understood
                                the
                                Terms and Conditions below and hereby accept the same. I understand that my personal
                                details as provided/available in the Bank/SBICAP Securities Limited records will be used
                                for CBDT reporting. Further, I hereby authorize SBICAP Securities Limited to furnish the
                                above information to the bank for the purpose of compliance and reporting under CBDT
                                Rules as applicable.</li>
                        </ul>
                    </div>
                    <div class="col-md-12 my-3">
                        <p class="h3"><strong>General</strong></p>
                    </div>
                    <div class="col-md-12">
                        <p>All the particulars and information given/provided to us are true, correct, accurate and
                            complete
                            and they shall form the basis of any loan or any other financial products as may be decided
                            to
                            grant to you. Also understand that SBICAP Securities Limited (SSL) is acting as a
                            distributor of
                            financial products / loan and for which the documents is required to be shared with the
                            manufacturer for processing.</p>
                        <p>You hereby authorise SSL or its relevant group companies, subsidiaries and affiliates as the
                            case
                            may be to contact you through any mode including making calls/sending SMS alerts, WhatsApp
                            on registered mobile phone number or sending e-mails to registered e-mail id for marketing
                            related information. You also confirm that this declaration/consent shall supersede,
                            substitute
                            and replace any other consent/confirmation issued in this regard previously and shall apply
                            whether or not the registered mobile number has been registered on “Do not Call” registry.
                        </p>
                    </div>
                    <div class="col-md-12 my-3">
                        <p class="h3"><strong>Declaration for Fund/Transfer facility</strong></p>
                    </div>
                    <div class="col-md-12">
                        <p>
                            I understand that 'Fund hold/Transfer' is an additional facility provided by SBICAP
                            Securities
                            Limited to its clients for facilitating online fund transfer on the trading portal. I
                            undertake that I
                            shall opt for alternate mode of payment i.e. VAN transfer/cheque payment etc. for meeting
                            trading/DP obligations, in the event of non-availability of 'Fund hold/Transfer'
                            functionality due
                            to any technical issue. I understand that in no event SBICAP Securities Limited shall be
                            responsible for any loss on account of any intermittent interruption resulting in
                            non-availability
                            of 'Fund hold/Transfer' facility and I shall not be entitled to claim for any actual or
                            notional loss
                            arising out of such interruption.
                        </p>
                    </div>
                    <div class="col-md-12 my-3">
                        <p class="h3"><strong>To open NRI Demat & Trading account with SBICAP Securities</strong></p>
                    </div>
                    <div class="col-md-12">
                        <p>
                            I hereby declare that the details furnished above are true and correct to the best of my
                            knowledge
                            and belief and I undertake to inform you of any changes therein, immediately. In case any of
                            the
                            above information is found to be false or untrue or misleading or misrepresenting, I am
                            aware
                            that I may be liable for it. I hereby declare and confirm that I have not been
                            prohibited/debarred
                            from dealing in securities and no penalty has been imposed on me for violation of securities
                            laws/other economic offences by SEBI or any other regulatory authorities. I also declare
                            that no
                            financial/criminal penalties or proceedings are pending against me. I hereby undertake to
                            notify
                            you forthwith of changes in this regard and shall not do anything in violation of such
                            orders, if
                            any at a later date. I give hereunder details of action taken by SEBI/Stock Exchanges/any
                            other
                            authorities for violation of Securities laws/other Economic offences during last three
                            years.
                        </p>
                    </div>
                    <div class="col-md-12 my-3">
                        <p class="h3"><strong>E-mail/ SMS and Voice Communications:</strong></p>
                    </div>
                    <div class="col-md-12">
                        <p>
                            All customers who register on our site agree, acknowledge and accept as per the terms and
                            conditions and that even if they are registered under NDNC, DND (Do Not Disturb), by
                            accepting
                            the terms, you authorize SBI CAP Securities Ltd, to call and assist you and/or SMS/E-Mail
                            the
                            customers by virtue of them having voluntarily registered
                            in <a href="https://www.sbisecurities.in" target="_blank">WWW.SBISECURITIES.IN.</a>
                            (Electronic and sms communications) SBI CAP Securities Ltd, will
                            not be responsible for any NDNC (National Do Not Call) Registry regulation that will come
                            into
                            play.
                        </p>
                    </div>
                </div>
            </div>
            <div class="modal-body" *ngIf="fatf">
                <div class="row mx-0">
                    <div class="col-lg-12 mb-2 pe-md-5 ps-md-2">
                        <ol type="1">
                            <li *ngFor="let country of fatfCountry">{{country.Country}}</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp (setScreen)="screenEvent($event)"></app-error-modal>